import * as $ from 'jquery';

export class MenuHelpers {
    static showMenu() {
        $(".main-navbar:not(.main-navbar--mijn-fnv)").removeClass("hidden");
        $(".main-navbar.main-navbar--mijn-fnv").addClass("hidden");
        $(".footer__fluid").addClass("hidden");
    }

    static hideMenu() {
        $(".main-navbar:not(.main-navbar--mijn-fnv)").addClass("hidden");
        $(".main-navbar.main-navbar--mijn-fnv").removeClass("hidden");
        $(".footer__fluid").addClass("hidden");
    }

    static showBreadCrumbs() {
        $(".breadcrumbs:not(.breadcrumbs.breadcrumbs--mijn-fnv-edit)").removeClass("hidden");
        $(".breadcrumbs.breadcrumbs--mijn-fnv-edit").addClass("hidden");
        $(".breadcrumb-item.mijn-fnv-react-added-breadcrumbs").remove();
    }

    static hideBreadCrumbs() {
        $(".breadcrumbs").addClass("hidden");
        $(".breadcrumbs.breadcrumbs--mijn-fnv-edit").addClass("hidden");
        $(".breadcrumb-item.mijn-fnv-react-added-breadcrumbs").remove();
    }

    static showBreadCrumbsEditPage() {
        $(".breadcrumbs").addClass("hidden");
        $(".breadcrumbs.breadcrumbs--mijn-fnv-edit").removeClass("hidden");
        $(".breadcrumb-item.mijn-fnv-react-added-breadcrumbs").remove();
    }

    static addBreadCrumbsParent(link : string, title : string) {
        $(".breadcrumb-item.mijn-fnv-react-added-breadcrumbs").remove();
        $(".breadcrumb-item.mijn-fnv__breadcrumb-for-edit-page").before("<li class='breadcrumb-item mijn-fnv-react-added-breadcrumbs'><a href='" + link + "'>"  + title + "</a></li>");
    }

    static updateMenu(email: string, FNVLidnummer: string, fullName: string) {
        $(".mijn-fnv__usermenu-username").text(fullName);
        $(".mijn-fnv__usermenu-lidnummer").text(FNVLidnummer);
        $(".mijn-fnv__usermenu-email").text(email);
        $(".main-navbar__primary-navbar-collapse .btn-success.main-navbar__nav-button").remove();
    }
}